import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import general from './general'
import error from './error'
import registration from './registration'
import user from './user'
import release from './release'
import information from './information'
import artist from './artist'
import signUp from './sign-up'
import report from './report'
import faq from './faq'
import contact from './contact'
import verify from './verify'
import payment from './payment'
import survey from './survey'
import lyrics from './lyrics'
import revenueAndShare from './revenueAndShare'
import link from './link'
import linkAnalytic from './link-analytic'
import copyright from './copyright'
import youtube from './youtube'

Vue.use(Router)
Vue.component('vue-router', Router)

const router = new Router({
  mode: 'history',
  routes: [
    ...general,
    ...error,
    ...registration,
    ...user,
    ...release,
    ...information,
    ...artist,
    ...signUp,
    ...report,
    ...faq,
    ...contact,
    ...verify,
    ...payment,
    ...survey,
    ...lyrics,
    ...revenueAndShare,
    ...link,
    ...linkAnalytic,
    ...copyright,
    ...youtube,
  ],
  scrollBehavior() {
    // ログインされてる場合.main-container利用, ログインされてない場合.content--secondary利用
    const scrollContainer = document.querySelector('.main-container') || document.querySelector('.content--secondary')
    if (scrollContainer) {
      scrollContainer.scrollTop = 0
    }
  },
})

function updateLocation(location) {
  store.commit('updateLocation', location)
}

function updateSideMenuId(sideMenuId) {
  store.commit('updateSideMenuId', sideMenuId)
}

function isStatic(path) {
  return path.indexOf('/client/static/') === 0
    || path.indexOf('/client/login') === 0
    || path.indexOf('/client/sign-up') === 0
    || path.indexOf('/client/narasumate') === 0
    || path.indexOf('/client/narasulife') === 0
    || path.indexOf('/client/contact') === 0
    || path.indexOf('/client/faqs') === 0
    || path.indexOf('/client/verify/') === 0
    || path.indexOf('/client/password-reset') === 0
}

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn']
  router.referrer = from

  // トークンなし＋行き先が非認証ページの場合
  if (!isLoggedIn && isStatic(to.path)) {
    updateLocation(to.meta.location)
    return next()
  }

  // トークンなし＋行き先がログイン画面以外の場合
  if (!isLoggedIn) {
    return next({ name: 'login' })
  }

  // トークンが有効か確認
  return store.dispatch('auth/check', { to: to.name })
    .then(() => {
      // 有効なトークン＋行き先がログイン画面の場合
      if (to.name === 'login') {
        return next({ name: 'index' })
      }
      // マッチする URL がないとき
      if (to.matched.length === 0) {
        return next({ name: 'index' })
      }
      // 有効なトークン＋行き先がログイン画面以外の場合
      updateLocation(to.meta.location)
      updateSideMenuId(to.meta.sideMenuId)
      return next()
    })
    .catch(() => {
      // 無効なトークン＋行き先がログイン画面の場合
      if (to.name === 'login') return next()

      // 無効なトークン＋行き先がログイン画面以外の場合
      return next({ name: 'login' })
    })
})

router.afterEach((to) => {
  // meta tagの書き替え
  const appName = document.getElementsByName('application-name')[0].content
  if (appName === process.env.MIX_APP_NAME_C) {
    const texts = {}
    switch (to.name) {
      case 'login':
        texts.title = 'ログイン｜narasu'
        texts.description = 'あなたの楽曲を世界へ。音楽ストリーミングサービスにあなたの楽曲を最短2日で配信！著作権の管理も可能な音楽ディストリビューター。月額110円のサブスクプランあり、払いきりプランなら更新料無料！'
        break
      case 'store-detail':
        texts.title = 'ストア詳細｜narasu'
        texts.description = 'サブスク型の楽曲配信代行サービスnarasuから配信できるストアの配信形式、配信地域、試聴時間やストアの特徴などを掲載。'
        break
      case 'faq':
      case 'faq-detail':
        texts.title = 'よくある質問｜narasu'
        texts.description = 'narasuの「よくあるご質問」のページです。レーベルおよびアーティストの皆さまからよくいただくご質問にお答えします。'
        break
      case 'terms':
        texts.title = '利用規約｜narasu'
        texts.description = 'narasuの利用規約について'
        break
      case 'copyright-terms':
        texts.title = '著作権管理サービス利用規約｜narasu'
        texts.description = 'narasuの著作権管理サービスの利用規約について'
        break
      case 'rules':
        texts.title = '配信規定｜narasu'
        texts.description = 'narasuの配信規定です。アカウント、リリース、コンテンツ、サービス及び利用料、収益についての規定を掲載しております。'
        break
      case 'environment':
        texts.title = '推奨環境｜narasu'
        texts.description = 'narasuをより安全にご利用いただくための推奨環境について '
        break
      case 'contact':
      case 'contact-confirm':
      case 'contact-complete':
        texts.title = 'お問い合わせ｜narasu'
        texts.description = 'ご不明点はこちらよりお問い合わせください。'
        break
      default:
        texts.title = 'narasu - 音楽配信代行サービス'
        texts.description = 'あなたの楽曲を世界へ。音楽ストリーミングサービスにあなたの楽曲を最短2日で配信！著作権の管理も可能な音楽ディストリビューター。月額110円のサブスクプランあり、払いきりプランなら更新料無料！'
    }
    document.title = texts.title
    document.querySelector("meta[name='description']").setAttribute('content', texts.description)
    document.querySelector("meta[property='og:site_name']").setAttribute('content', texts.title)
    document.querySelector("meta[property='og:title']").setAttribute('content', texts.title)
    document.querySelector("meta[property='og:description']").setAttribute('content', texts.description)
    document.querySelector("meta[property='twitter:title']").setAttribute('content', texts.title)
    document.querySelector("meta[property='twitter:description']").setAttribute('content', texts.description)
  }
})
export default router
